import React from 'react';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import useBuilderStore from '../store/useBuilderStore';
import Row from './Row';

const Canvas = ({ isPreview = false, idPrefix = '', scale = 1 }) => {
  const { layout, globalSettings, setSelectedElement } = useBuilderStore();

  const canvasStyle = {
    backgroundColor: globalSettings.containerColor,
    width: '100%',
    maxWidth: isPreview ? '100%' : `${globalSettings.containerWidth}px`,
    margin: '0 auto',
    minHeight: isPreview ? '100%' : '600px',
    borderRadius: isPreview ? '0px' : '12px',
    border: isPreview ? 'none' : `1px solid ${globalSettings.borderColor}`,
    padding: '0px',
    overflow: 'hidden',
    boxShadow: isPreview ? 'none' : '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  };

  const pageStyle = {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: isPreview ? globalSettings.pageColor : 'transparent',
  };

  return (
    <div 
      style={pageStyle} 
      className={`${!isPreview ? 'canvas-viewport animate-in fade-in zoom-in-95 duration-500' : 'h-full'}`}
      onClick={() => setSelectedElement(null)}
    >
      <div style={canvasStyle} className={`canvas-container relative ${!isPreview ? 'group' : ''}`}>
        {!isPreview && (
          <div className="absolute -top-6 left-0 flex items-center gap-2 px-3 py-1 bg-white border border-slate-100 rounded-t-lg shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
             <div className="w-1.5 h-1.5 rounded-full bg-slate-300"></div>
             <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Main Canvas</span>
          </div>
        )}
        <SortableContext 
          items={layout.map(r => `${idPrefix}${r.id}`)} 
          strategy={verticalListSortingStrategy}
        >
          {layout.map((row) => (
            <Row key={row.id} row={row} isPreview={isPreview} idPrefix={idPrefix} scale={scale} />
          ))}
        </SortableContext>
        
        {layout.length === 0 && !isPreview && (
          <div className="flex flex-col items-center justify-center h-[400px] text-slate-400 gap-4">
            <svg className="w-12 h-12 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            <p className="italic">Drag a row or block here to start building</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Canvas;
